export default __webpack_public_path__ + "static/media/play.5350b50f.svg";